import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledCart = styled.div<{ isView?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 0 20px;
  padding-top: 30px;

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: flex;
    justify-content: center;
    flex-direction: ${({ isView }) => (isView ? 'column-reverse' : 'column')};
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    padding-top: 0;
    .form-title {
      display: block;
    }
  }
`;

export const StyledCartWrapper = styled.div`
  .form-title {
    display: none;
    margin-top: 14px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .cart-page-title.mobile {
      h1 {
        font-size: 1.5rem;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .form-title {
      display: block;
    }
  }
`;
